var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"fill-height"},[_c('App-Bar'),_c('v-main',[_c('Video-View')],1),_c('Foot-Bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }